/// <amd-module name="VSS/Diagnostics/UI/Components/Exceptions/Exceptions" />
import * as React from "react";

import { ContributionServiceEvent, IDataProviderQueryCompletedEvent, IVssContributionService } from "VSS/Platform/Contribution";
import { Components, VssComponent, WrappedComponent } from "VSS/Platform/Layout";

interface IExceptionsState {
    dataProviderExceptionCount: number;
    showDataProviderExceptions: boolean;
}

class Exceptions extends VssComponent<{}, IExceptionsState> {
    public state = { dataProviderExceptionCount: 0, showDataProviderExceptions: false };

    public render(): JSX.Element | null {
        if (this.state.dataProviderExceptionCount) {
            return (
                <React.Fragment>
                    <span key="exceptions-section" className="perf-section warning actionable" onClick={this.showDataProviderExceptions}>
                        Data provider exceptions ({this.state.dataProviderExceptionCount})
                    </span>
                    {this.state.showDataProviderExceptions ? (
                        <WrappedComponent
                            dependencies={["ms.vss-features.diag-dialog-content"]}
                            wrappedType={"vss.perf-data-provider-exceptions-dialog"}
                            onDismiss={this.hideDataProviderExceptions}
                        />
                    ) : null}
                </React.Fragment>
            );
        }

        return null;
    }

    public componentDidMount(): void {
        super.componentDidMount();

        const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
        contributionService.subscribe(this.dataProviderQueryCompleted, ContributionServiceEvent.DataProviderQueryCompleted);
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();

        const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
        contributionService.unsubscribe(this.dataProviderQueryCompleted, ContributionServiceEvent.DataProviderQueryCompleted);
    }

    private dataProviderQueryCompleted = (queryEndEvent: IDataProviderQueryCompletedEvent) => {
        if (queryEndEvent.dataProviderExceptions) {
            this.setState({
                dataProviderExceptionCount: Object.keys(queryEndEvent.dataProviderExceptions).length
            });
        }
    };

    private hideDataProviderExceptions = () => {
        this.setState({ showDataProviderExceptions: false });
    };

    private showDataProviderExceptions = () => {
        this.setState({ showDataProviderExceptions: true });
    };
}

Components.add("perfbar.exceptionsSection", Exceptions);
